import React, { useState, Ref } from 'react'
import { Box, Button, CardMedia, Grid, Typography, useMediaQuery } from '@material-ui/core'
import Linkify from 'react-linkify'
import FootprintIcon from 'assets/images/footprint.svg'
import DownloadIcon from 'assets/images/download.svg'
import PlayVideoIcon from 'assets/images/video.svg'

import { useStyles } from 'styles/styles'
import { useTextLookup } from 'utils/text'
import Feature from 'models/Feature'
import VideoPlayerDialog from 'components/widgets/VideoPlayerDialog'
import FeatureGridDialog from 'components/widgets/FeatureGridDialog'

interface ContentCardProps {
    cardRef?: Ref<HTMLDivElement>
    className: string
    feature: Feature
    onDownloadImage?: (name: string) => void
}

const ContentCard: React.FC<ContentCardProps> = (props) => {
    const { cardRef, className, feature } = props
    const classes = useStyles()
    const _t = useTextLookup()
    const sm = useMediaQuery('(max-width:600px)')
    const [videoPlayerOpen, setVideoPlayerOpen] = useState(false)
    const [dialogOpen, setDialogOpen] = useState(false)


    const handleDownloadImage = (name: string) => {
        props.onDownloadImage?.(name)
    }

    const handleVideoPlayerOpen = () => {
        setVideoPlayerOpen(true)
    }

    const handleVideoPlayerClose = () => {
        setVideoPlayerOpen(false)
    }

    const handleGridButton = () => {
        setDialogOpen(true)
    }

    const handleDialogClose = () => {
        setDialogOpen(false)
    }

    return (
        <React.Fragment>
            <div ref={cardRef} className={className}>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6}>
                        <CardMedia className={classes.cardImage} image={feature.image} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="h4" color="primary">{feature.name}</Typography>
                        <Linkify>
                            <Typography className={classes.paragraph} style={{wordWrap: 'break-word'}}>{feature.content}</Typography>
                        </Linkify>
                        <Typography className={classes.paragraph} variant="h6" >{_t("topic_content.feature_location")}</Typography>
                        <Typography variant="body1">{feature.featureLocation}</Typography>
                    </Grid>
                    {!cardRef && 
                        <React.Fragment>
                            <Grid item xs={6} sm={6}>
                                <Box className={classes.cardButtonBar} display="flex" flexDirection={sm ? "column" : "row"} justifyContent="flex-start">
                                    {typeof (navigator.msSaveBlob) === "undefined" &&
                                        <Button startIcon={<img src={DownloadIcon} style={{height: '36px'}} alt="" />} onClick={e => handleDownloadImage(feature.name)}>{_t("topic_content.download_button")}</Button>
                                    }
                                    {!!feature.video &&
                                        <Button startIcon={<img src={PlayVideoIcon} style={{ height: '36px' }} alt="" />} onClick={handleVideoPlayerOpen}>{_t("topic_content.video_button")}</Button>
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Box className={classes.cardButtonBar}>
                                    {/* <Button startIcon={<img style={{ height: '48px' }} src={FootprintIcon} alt="" />} variant="text" onClick={handleGridButton}>{_t("topic_content.footprint_button")}</Button> */}
                                    {/* <FeatureGridDialog open={dialogOpen} onDialogClose={handleDialogClose} /> */}
                                </Box>
                            </Grid>
                        </React.Fragment>
                    }
                </Grid>
            </div>
            {!!feature.video &&
                <VideoPlayerDialog videoUrl={feature.video} open={videoPlayerOpen} onDialogClose={handleVideoPlayerClose} />
            }
        </React.Fragment>
    )
}

export default ContentCard
